import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { ServicecallService } from 'src/app';
import { ApiConstants } from 'src/app/constants/api-constants';
import { EntityModel } from 'src/app/model';
import { DataService, ImageUrlCacheService } from 'src/app/services';
import { EntitiesServiceService } from 'src/app/shared/services';

@Component({
  selector: 'app-tile-body-validops-vehicle',
  templateUrl: './tile-body-validops-vehicle.component.html',
  styleUrl: './tile-body-validops-vehicle.component.css'
})
export class TileBodyValidopsVehicleComponent implements OnInit {

  @Input() content: EntityModel;

  @Input() pageType: 'people' | 'assets' | 'vehicles';


  private _tenantGenericConfig: any = {};
  public defaultImage: string = null;
  public token: string = ApiConstants?.blobSasToken;
  public imageLoaded = false;

  constructor(
    public service: EntitiesServiceService,
    private _sharedService: ServicecallService,
    private _imageUrlCacheService: ImageUrlCacheService,
    private _dataService: DataService
  ) { }

  ngOnInit(): void {
    this._tenantGenericConfig = this._sharedService.getConfiguration('tenantGenericConfig') ? this._sharedService.getConfiguration('tenantGenericConfig') : null;
    const configBasedOnCategory = this._sharedService.getConfigurationBasedOnCategory(this.content);
    this.defaultImage = configBasedOnCategory ? configBasedOnCategory?.defaultImage?.[this.content?.category] : this._tenantGenericConfig?.defaultImage?.[this.content?.category];
  }


  onImageLoad(): void {
    this.imageLoaded = true;
  }

  /**
   * Determines whether image error on
   * @param content 
   */
  onImageError(content: any): void {    
    this.imageLoaded = false;
  }
}

